<template lang="html">
<div class="wcc footer">
  <!-- <a href="http://macrealty.ca" rel="noopener noreferrer" target="_blank">
    <img src="@/assets/macdonald_realty_two_colour_logo.png" alt="Madonald Realty Logo">
  </a> -->
  <p>The calculations provided above, while deemed correct, cannot be guaranteed.</p>
  <p>© {{year}} Macdonald Realty Westmar</p>
</div>
</template>
<script>
  export default {
    data() {
      return {
        year: (new Date()).getFullYear(),
      }
    }
  }
</script>
<style lang="scss">
  .wcc.footer {
    padding: $spacing;
    text-align: center;
    font-size: .8em;
    color: $grey-500;
    overflow: auto;

    > * {
      margin-bottom: 0;
      &:first-child {
        margin-top: 0
      }
      &:not(:first-child) {
        margin-top: $spacing/2;
      }
    }
  }
</style>